import { useContext } from 'react';
import AppContext from '../../../AppContext';
import { DollarFormat } from '../../format';
import MedicalLossRatioRebatesRowData from './MedicalLossRatioRebatesRowData';
import RowHelmet from '../RowHelmet';
import styles from './MedicalLossRatioRebatesRow.module.css';

export default function MedicalLossRatioRebatesRow({
  sectionKey,
  rowKey,
  label,
  individualCurrentYear,
  individualPriorYear,
  smallGroupCurrentYear,
  smallGroupPriorYear,
  largeGroupCurrentYear,
  largeGroupPriorYear,
  otherCurrentYear,
  otherPriorYear
}: MedicalLossRatioRebatesRowData) {
  const { showBenchmark } = useContext(AppContext);
  const id = `${sectionKey}-${rowKey}`;

  return (
    <div
      id={id}
      data-testid={id}
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}>
      <RowHelmet label={label} />
      <p></p>
      <p></p>
      <DollarFormat {...individualCurrentYear} />
      <DollarFormat {...individualPriorYear} />
      <DollarFormat {...smallGroupCurrentYear} />
      <DollarFormat {...smallGroupPriorYear} />
      <DollarFormat {...largeGroupCurrentYear} />
      <DollarFormat {...largeGroupPriorYear} />
      <DollarFormat {...otherCurrentYear} />
      <DollarFormat {...otherPriorYear} />
    </div>
  );
}
